/**
 * Convert hex color to RGB values
 */
export const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  // Remove # if present
  const cleanHex = hex.replace('#', '');
  
  // Parse hex values
  const result = /^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(cleanHex);
  
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

/**
 * Generate pulsing ring color with transparency from solid hex color
 */
export const generatePulsingColor = (hexColor: string, opacity: number = 0.2): string => {
  const rgb = hexToRgb(hexColor);
  
  if (!rgb) {
    return `rgba(0, 0, 0, ${opacity})`;
  }
  
  return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`;
};

/**
 * Generate border color with transparency from solid hex color
 */
export const generateBorderColor = (hexColor: string, opacity: number = 0.2): string => {
  // For borders, we want a lighter version - use white with opacity over the base color
  return `rgba(255, 255, 255, ${opacity})`;
};
